;(function () {

"use strict";

var InstagramView = require('../views/instagram');
var SliderView = require('../views/slider');

var HeroSliderView = SliderView.extend({
  initialize: function (opts) {
    SliderView.prototype.initialize.call(this, opts);
    this.startTimer();
  },
  stopTimer: function () {
    clearInterval(this.interval);
    this.interval = undefined;
  },
  startTimer: function () {
    if (this.interval) { clearInterval(this.interval); }
    this.interval = setInterval(_.bind(this.next, this), 7000);
  },
  navClick: function (e) {
    SliderView.prototype.navClick.call(this, e);
    this.engaged = true;
    this.stopTimer();
  },
  mouseenter: function () {
    if (!this.engaged) { return; }
    this.stopTimer();
  },
  mouseleave: function () {
    if (!this.engaged) { return; }
    this.startTimer();
  },
  events: _.extend({}, SliderView.prototype.events, {
    'mouseenter': 'mouseenter',
    'mouseleave': 'mouseleave'
  })
});

var PageView = Backbone.View.extend({
  initialize: function () {
    // console.log('init index page');
    new InstagramView({ el: this.$el.find('.instagram') });

    new HeroSliderView({ el: this.$el.find('.hp-slider') });

    new SliderView({ el: this.$el.find('.featured-products .slider.desktop'), group: 5 });
    new SliderView({ el: this.$el.find('.new-products .slider.desktop'), group: 5 });

    new SliderView({ el: this.$el.find('.featured-collections .slider.desktop'), group: 3 });

    new SliderView({ el: this.$el.find('.mobile-hp-slider') });
    new SliderView({ el: this.$el.find('.featured-products .slider.mobile') });
    new SliderView({ el: this.$el.find('.featured-collections .slider.mobile') });

    new SliderView({ el: this.$el.find('.press .slider.mobile') });
  }
})

module.exports = PageView;

}());